if (!customElements.get('carousel-pswp')) {
  class CarouselPswp extends HTMLElement {
    constructor() {
      super();

      this.photoSwipeLightboxInit();
    }

    photoSwipeLightboxInit() {
      const [
        zoomContainerWidth,
        zoomContainerHeight,
        closeIcon,
        prevIcon,
        nextIcon
      ] = [
        this.offsetWidth,
        this.offsetHeight,
        this.querySelector('[data-close-icon]'),
        this.querySelector('[data-prev-icon]'),
        this.querySelector('[data-next-icon]')
      ];

      function isPhone() {
        return window.innerWidth < 750;
      }
      const allSection = document.querySelector("[data-section-full-all]");
      let gallery = '.carousel-pswp';
      if (allSection) {
        gallery = document.body;
      }

      const photoSwipeLightboxInstance = new PhotoSwipeLightbox({
        gallery: gallery,
        children: "a.carousel__gallery-toggle",
        mainClass: "pswp--carousel-gallery",

        loop: false,
        showHideAnimationType: "zoom",

        initialZoomLevel: zoomLevelObject => {
          if (isPhone()) {
            return zoomLevelObject.vFill;
          } else {
            return zoomLevelObject.fit;
          }
        },
        secondaryZoomLevel: zoomLevelObject => {
          if (isPhone()) {
            return zoomLevelObject.fit;
          } else {
            return 1;
          }
        },
        pswpModule: PhotoSwipe,
        padding: function(viewportSize, itemData) {
          var el = itemData && itemData.element;
          var hasLook = el && el.dataset && el.dataset.lookInfoId;
          if (!hasLook) {
            return { top: 0, bottom: 0, left: 0, right: 0 };
          }
          if (viewportSize.x >= 750) {
            return { top: 60, bottom: 60, left: Math.round(viewportSize.x * 0.20), right: Math.round(viewportSize.x * 0.28) };
          }
          return { top: 0, bottom: 0, left: 0, right: 0 };
        }
      });


      photoSwipeLightboxInstance.addFilter(
        'uiElement',
        (element, data) => {
          if (data.name === 'close') {
            element.innerHTML = closeIcon.innerHTML;
          } else if (data.name === 'arrowPrev') {
            element.innerHTML = prevIcon.innerHTML;
          } else if (data.name === 'arrowNext') {
            element.innerHTML = nextIcon.innerHTML;
          }
          return element;
        }
      );
      
      photoSwipeLightboxInstance.init();

      photoSwipeLightboxInstance.on('beforeOpen', () => {
        document.body.classList.add("oveflow-hidden");
      });

      photoSwipeLightboxInstance.on("closingAnimationStart", () => {
        document.body.classList.remove("oveflow-hidden");
      });

      photoSwipeLightboxInstance.on('firstUpdate', function() {
        var pswp = photoSwipeLightboxInstance.pswp;
        if (!pswp) return;

        pswp.element.setAttribute('role', 'dialog');
        pswp.element.setAttribute('aria-modal', 'true');

        var closeLabel = closeIcon.dataset.closeLabel || 'Close';

        var overlay = document.createElement('div');
        overlay.className = 'pswp-look-overlay';
        overlay.setAttribute('aria-live', 'polite');
        overlay.innerHTML = '<button class="pswp-look__close" type="button" aria-label="' + closeLabel + '">' + closeIcon.innerHTML + '</button><div class="pswp-look__info"></div><div class="pswp-look__image"></div><div class="pswp-look__details"></div><div class="pswp-look__nav"><button class="pswp-look__nav-btn pswp-look__nav-btn--prev" aria-label="Previous look">' + prevIcon.innerHTML + '</button><button class="pswp-look__nav-btn pswp-look__nav-btn--next" aria-label="Next look">' + nextIcon.innerHTML + '</button></div>';

        var closeBtn = overlay.querySelector('.pswp-look__close');
        var navPrev = overlay.querySelector('.pswp-look__nav-btn--prev');
        var navNext = overlay.querySelector('.pswp-look__nav-btn--next');
        closeBtn.addEventListener('click', function() { pswp.close(); });
        navPrev.addEventListener('click', function() { pswp.prev(); });
        navNext.addEventListener('click', function() { pswp.next(); });
        pswp.element.appendChild(overlay);

        // On mobile the overlay covers PhotoSwipe's own UI, so the browser
        // back button must dismiss the look card instead of leaving the page.
        var closedByHistory = false;
        var onPopstate = function() {
          closedByHistory = true;
          pswp.close();
        };
        history.pushState({ pswpLook: true }, '');
        window.addEventListener('popstate', onPopstate);
        pswp.on('destroy', function() {
          window.removeEventListener('popstate', onPopstate);
          if (!closedByHistory && history.state && history.state.pswpLook) {
            history.back();
          }
        });

        var infoPanel = overlay.querySelector('.pswp-look__info');
        var imagePanel = overlay.querySelector('.pswp-look__image');
        var detailsPanel = overlay.querySelector('.pswp-look__details');

        function updateLookInfo() {
          overlay.scrollTop = 0;

          var slide = pswp.currSlide;
          var el = slide && slide.data && slide.data.element;
          var templateId = el && el.dataset && el.dataset.lookInfoId;
          var tpl = templateId ? document.getElementById(templateId) : null;

          if (!tpl) {
            overlay.classList.remove('is--visible');
            imagePanel.innerHTML = '';
            return;
          }

          var clone = tpl.content.cloneNode(true);
          var infoSrc = clone.querySelector('.pswp-look__info');
          var detailsSrc = clone.querySelector('.pswp-look__details');

          infoPanel.innerHTML = infoSrc ? infoSrc.innerHTML : '';
          detailsPanel.innerHTML = detailsSrc ? detailsSrc.innerHTML : '';

          if (slide.data.src) {
            imagePanel.innerHTML = '<img src="' + slide.data.src + '" alt="">';
          } else {
            imagePanel.innerHTML = '';
          }

          overlay.classList.add('is--visible');

          navPrev.disabled = pswp.currIndex === 0;
          navNext.disabled = pswp.currIndex >= pswp.getNumItems() - 1;
        }

        pswp.on('change', updateLookInfo);
        updateLookInfo();

        if (isPhone() && overlay.classList.contains('is--visible')) {
          closeBtn.focus({ preventScroll: true });
        }
      });

      this.addEventListener('dragstart', event => {
        event.preventDefault();
      });

      // Enable mobile image click to open lightbox
      // When a separate mobile image is uploaded, the desktop <a> gets small-hide
      // and the mobile container renders a bare <img> with no PhotoSwipe trigger.
      // This delegates mobile clicks to the hidden desktop <a>.
      this.querySelectorAll('.section-carousel__media.small-up-hide').forEach(function(mobileMedia) {
        mobileMedia.style.cursor = 'pointer';
        mobileMedia.addEventListener('click', function() {
          var slide = mobileMedia.closest('.swiper-slide');
          if (!slide) return;
          var desktopLink = slide.querySelector('a.carousel__gallery-toggle');
          if (desktopLink) desktopLink.click();
        });
      });
    }
  }

  customElements.define('carousel-pswp', CarouselPswp);
}
